export const borders = {
    border: 'border: 1px solid',
    borderTop: 'border-top: 1px solid',
    borderBottom: 'border-bottom: 1px solid',
    borderLeft: 'border-left: 1px solid',
    borderRight: 'border-right: 1px solid',
    borderRightDashed: 'border-right: 3px dashed',
};
